import React, { useEffect, useState } from "react";
import { Heart, Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock";

export default function Navbar({ onJoin, onLogin, isMember, onNav, active }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const f = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", f);
    return () => window.removeEventListener("scroll", f);
  }, []);

  const go = (id) => { setOpen(false); onNav(id); };

  return (
    <header className={`fixed top-0 inset-x-0 z-50 nav-bar ${scrolled ? "nav-scrolled" : ""}`}>
      <div className="max-w-[1024px] mx-auto px-6 lg:px-0 lg:pl-[64px] lg:pr-[33px] h-[86px] flex items-center justify-between">
        <button onClick={() => go("home")} className="logo-script flex items-start" data-testid="logo">
          Silky Maya<Heart className="w-7 h-7 text-[#ee3a70] ml-1.5 mt-1.5" fill="currentColor" />
        </button>
        <nav className="hidden lg:flex items-center gap-[30px] -ml-20">
          {NAV_LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-${l.id}`}
              className={`nav-link ${active === l.id ? "nav-active" : ""}`}>{l.label}</button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {!isMember && <button onClick={onLogin} className="hidden sm:inline text-white/90 hover:text-white text-[15px] mr-2" data-testid="nav-login">Log in</button>}
          <button onClick={onJoin} className="btn-join" data-testid="nav-join-vip">{isMember ? "My Space" : "Join VIP"}</button>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden bg-[#1d181b]/95 backdrop-blur px-6 pb-5 flex flex-col gap-3">
          {NAV_LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="text-left text-white/90 py-1.5">{l.label}</button>
          ))}
          {!isMember && <button onClick={() => { setOpen(false); onLogin(); }} className="text-left text-[#ff8fb3] py-1.5" data-testid="mobile-login">Member log in</button>}
        </div>
      )}
    </header>
  );
}
